<template>
  <content-container :table-row-count="tableData.length">
    <!-- 搜索条件区域 -->
    <search-container>
      <search-col>
        <el-input v-model="params.companyNo" placeholder="企业编号" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-input v-model="params.companyName" placeholder="企业名称" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-input v-model="params.unitNo" placeholder="账户" clearable @keydown="onEnter" />
      </search-col>
      <search-col>
        <el-input v-model="params.bankAccount" placeholder="来账银行账号" clearable @keydown="onEnter" />
      </search-col>

      <template #buttons>
        <el-button @click="resetForm">
          <svg-icon icon="tabler:refresh" />重置
        </el-button>
        <el-button type="primary" @click="doSearch">
          <svg-icon icon="lucide:search" />查询
        </el-button>
      </template>
    </search-container>
    <div>
      <el-button class="mb-[20px]" type="primary" @click="exportFile">
        <svg-icon icon="lucide:square-arrow-out-up-right" />导出
      </el-button>
    </div>

    <!-- 表格数据 -->
    <el-table v-loading="loading" class="normal-table" :border="true" :scrollbar-always-on="true" :data="tableData" :cell-style="initOperatorColumnStyle">
      <el-table-column align="center" type="index" label="序号" :min-width="80" />
      <el-table-column align="center" prop="companyNo" label="企业编号" :min-width="160" />
      <el-table-column align="center" prop="companyName" label="企业名称" :min-width="220" show-overflow-tooltip />
      <el-table-column align="center" prop="unitNo" label="账户" :min-width="220" show-overflow-tooltip />
      <el-table-column align="center" prop="accountList" label="来账银行账号" :min-width="220" show-overflow-tooltip>
        <template #default="scope">
          <el-button type="text" @click="handleDetail(scope.row)">
            查看
          </el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="balance" label="可用金额(元)" :min-width="160" />
      <el-table-column align="center" prop="rechargeAmount" label="充值总金额(元)" :min-width="140" />
      <el-table-column align="center" prop="withdrawAmount" label="总提现金额(元)" :min-width="160" />
      <el-table-column align="center" prop="withdrawServiceAmount" label="总提现服务费(元)" :min-width="160" />
    </el-table>

    <!-- 底部分页 -->
    <template #footer>
      <el-pagination
        v-model:current-page="params.page"
        v-model:page-size="params.size"
        :page-sizes="[defaultPageSize, 25, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        @size-change="onSizeChange"
        @current-change="onCurrentPageChange"
      />
    </template>
    <BankListDialog v-model:visible="bankListDialogVisible" :bank-list="bankList" @close="bankListDialogVisible = false" />
  </content-container>

  <!-- 驳回原因 -->
</template>

<script setup lang="ts">
import BankListDialog from './dialogs/BankList.vue';
import { reactive, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { initOperatorColumnStyle, SvgIcon } from '@vue3/components';
import {
  ContentContainer,
  SearchContainer,
  SearchCol,
  queryAlipayUnitPage,
  exportAlipayUnit,
  getCustomState,
} from '@core/main';
import { IAlipayUnitDetail, IAlipayUnitPageRequest } from '@core/main/types';
import { downloadFile } from '@core/tools';

defineOptions({ name: 'AlipayUnit' });

const defaultPageSize = 12;

const params = reactive<IAlipayUnitPageRequest>({
  page: 1,
  size: defaultPageSize,
});

const loading = ref(false);
const total = ref(0);
const state = getCustomState<any>();
const tableData = ref<IAlipayUnitDetail[]>([]);

const bankListDialogVisible = ref(false);
const bankList = ref<{ bankName: string; bankAccount: string }[]>([]);

async function exportFile() {
  try {
    const { buffer, fileName } = await exportAlipayUnit({
      ...params,
      serverId: state.businessId,
    });

    downloadFile(buffer, fileName, 'xlsx');

    ElMessage.success('导出成功');
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
}

async function fetchData() {
  loading.value = true;

  try {
    const res = await queryAlipayUnitPage({
      ...params,
      serverId: state.businessId,
    });

    tableData.value = res.data;
    total.value = res.total;
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }

  loading.value = false;
}

function resetForm() {
  for (const key in params) {
    if (!['page', 'size'].includes(key)) {
      params[key] = undefined;
    }
  }
}

function handleDetail(row: any) {
  bankListDialogVisible.value = true;
  bankList.value = row.accountList;
}

function onSizeChange(size: number) {
  params.size = size;
  params.page = 1;
  fetchData();
}

function onCurrentPageChange(page: number) {
  params.page = page;
  fetchData();
}

function onEnter(e) {
  if (e.keyCode === 13) doSearch();
}

function doSearch() {
  params.page = 1;
  fetchData();
}

fetchData();
</script>
